/**
 * This should be normalized with the normal request type model at some point
 */
export type { RequestTypeSuggestion, RequestTypeSuggestionState } from './reducer';
export { default as requestTypeSuggestionReducer } from './reducer';
